// services/eventService.js
import apiClient from './apiClient';

// Servicio para obtener todos los eventos
const getAllEvents = async (search = "") => {
    try {
        const params = {};

        // Solo agrega 'search' si tiene valor
        if (search.trim() !== "") {
            params.search = search.trim();
        }

        const response = await apiClient.get("/eventos", { params });
        return response.data;
    } catch (error) {
        console.error("Error al obtener los eventos:", error.message);
        throw new Error("No se pudieron cargar los eventos");
    }
};
const getEventForSlug = async (slug) => {
    try {
        const response = await apiClient.get(`/eventos/${slug}`);
        return response.data; 
    } catch (error) {
        console.error('Error al obtener los eventos:', error);
        throw error;
    }
};

export default {
    getAllEvents,
    getEventForSlug
};
